export default __webpack_public_path__ + "static/media/TOP-P14-3-2mm-open.3235d891.dwg";